import { render, staticRenderFns } from "./RequestsStatus.vue?vue&type=template&id=23186e67&"
import script from "./RequestsStatus.vue?vue&type=script&lang=js&"
export * from "./RequestsStatus.vue?vue&type=script&lang=js&"
import style0 from "./RequestsStatus.vue?vue&type=style&index=0&id=23186e67&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports